import './storyCard.css'
import { useRef, useState, useEffect } from 'react';
import Card from './cardStory';
import axios from 'axios';
    
export default function Liveprop (){

    const [story, setStory]= useState([])
    useEffect(()=>{
      const fetchData=async()=>{
        try{
            const response = await axios.get(`${process.env.React_APP_API_URL}/api/v1/story?live=y`);
            if(response.status===200){
              setStory(response.data)
            }
        }catch(err) {
            console.log(err)
        }
    }

    fetchData()

    },[])

    const sliderWidth = `${story.length*350+50}px`
    
    const scrollableRef = useRef(null);

    const handleMouseEnter = () => {
      const scrollable = scrollableRef.current;
      if (scrollable) {
        scrollable.addEventListener('wheel', handleScroll);
      }
    };
  
    const handleMouseLeave = () => {
      const scrollable = scrollableRef.current;
      if (scrollable) {
        scrollable.removeEventListener('wheel', handleScroll);
      }
    };
  
    const handleScroll = (e) => {
      const scrollable = scrollableRef.current;
      if (scrollable) {
        e.preventDefault();
        scrollable.scrollLeft += e.deltaY*.5;

        if (scrollable.scrollLeft === (scrollable.scrollWidth - scrollable.clientWidth)) {
            scrollable.removeEventListener('wheel', handleScroll);
          } else if (scrollable.scrollLeft <= 0) {
            scrollable.scrollLeft = 0;
            scrollable.removeEventListener('wheel', handleScroll);
          }
      }

    }
    return(
        <div 
        className='pop-slider-container'
        ref={scrollableRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}>
            <div className='pop-slider livePad' style={{width:`${sliderWidth}`}}>
                {story.map((item, key)=>{
                    return(
                        <Card
                        item={item}
                        key={key}/>
                    )
                })}
            </div>
        </div>
        
    )
}